import React, { ReactNode } from 'react';

import cn from 'classnames';

import { SvgInfo } from 'components/icons';

import styles from './InfoAlert.module.less';

interface Props {
    text: string | ReactNode;
    className?: string;
}

export const InfoAlert = ({ text, className }: Props) => (
    <div data-testid="info-alert" className={cn(styles.InfoAlert, className)}>
        <div className={styles.InfoAlert__IconContainer}>
            <SvgInfo />
        </div>
        <div className={styles.InfoAlert__TextContainer}>{text}</div>
    </div>
);
